import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import LogoAcademy from "assets/images/LogoAcademy.png";
import "./index.scss";

const AuthLayout = () => {
  const location = useLocation();

  const getBackgroundClass = () => {
    switch (true) {
      case location.pathname === "/login":
        return "bg-login";
      case location.pathname === "/national-code":
        return "national-code";
      case location.pathname === "/personalInfo":
        return "bg-personal-info";
      case location.pathname === "/country":
        return "bg-country";
      case location.pathname.startsWith("/postalcode"):
        return "bg-postalcode";
      case location.pathname === "/card-issuance":
        return "bg-card-issuance";
      default:
        return "";
    }
  };

  return (
    <Box className="auth-layout-wrapper">
      <Box className="main-box">
        <Box className={`left-box ${getBackgroundClass()}`}></Box>
        <Box className="right-box">
          <Box className="top-bar">
            <img src={LogoAcademy} alt="On Academy" />
          </Box>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayout;
